import { render, staticRenderFns } from "./DatabaseBackups.vue?vue&type=template&id=1b92f680&scoped=true&"
import script from "./DatabaseBackups.vue?vue&type=script&lang=js&"
export * from "./DatabaseBackups.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseBackups.vue?vue&type=style&index=0&id=1b92f680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b92f680",
  null
  
)

export default component.exports